/**
 * Created by dev on 8/31/2016.
 */
import * as actionTypes from './../constants/actionTypes';
import * as _ from "lodash";
import { Map, List, fromJS } from 'immutable';

export const UI_POPUP_TYPES = {
  referral: "referral",
  associateJobFabricator: "associateJobFabricator",
  fabricatorTwoFA: "fabricatorTwoFA",
  accountACHCredentials: "accountACHCredentials",
  accountACHContract: "accountACHContract",
  discountsDisplayOptions: "discountsDisplayOptions",
}

const getDefaultUiPopupState = () => {
  return {
    headerTextId: "",
    style: null,
    className: "",
    opened: false,
    type: 0,
    context: {}, // here we store all popup values
    buttons: [],
  }
}

/**
 * 1. define an object that will hold data
 * 2. update setPopupLayerVisibility method to show needed layer based on p.1
 * 3. update templates/pagesLayout.rt to show needed layer base on p.2
 */

const initialState = {
  // layer 0
  jobBoard: false,
  jobBoardExportPopupVisible: false,
  calendar: false,
  filterGroupVisualStyle: false,
  filtersAssignToFeatures: false,
  filtersAssignToStones: false,
  showSwitchUserPopup: false,

  // layer 1
  scheduleEntry: false, // window to create a schedule entry
  chooseEmailTemplate: false,
  showCategoryImagePopup: null, // could be set a number(which category to edit) or null(hidden),
  showFeatureGroupImagePopup: false, // boolean, is set when feature group object come (activeImageEditFeatureGroup)
  showPaymentGatewayPopup: false, // boolean
  showManufacturerFiltersPopup: false, // boolean
  showCliqSubMidInfoPopup: false, // boolean
  showCreditCardPopup: false, // boolean
  showAssignQuotePopup: false, // boolean
  showJobBoardFiltersPopup: false, // boolean
  wizardPopupOpened: false, // boolean
  featuresSetupTogglePopupOpened: false, // boolean
  featuresSetupDeletePopupOpened: false, // boolean
  showShippingSetupPopup: false, // boolean
  showMarkUpDownPopup: false, // boolean
  questionPopupState: {
    className: "",
    showPopup: false,
    questionMessage: "",
    yesClick: null, // should be a function
    noClick: null // should be a function
  },
  permissionsPopupState: {
    showPopup: false,
    user: {},
    entityType: "",
    handleClosePopup: () => { }
  },
  resetPasswordPopupState: {
    showPopup: false,
    user: {},
    password: '',
    confirmPassword: '',
    changePasswordSuccess: false,
    resetPasswordSuccess: false
  },
  docuSignPopupState: {
    showPopup: false,
    ds_sandBoxUserId: "",
    ds_sandBoxAuthToken: "",
    ds_prodClientId: "",
    ds_prodUserId: "",
    ds_prodPrivateKey: "",
    ds_checkOutContractId: "",
    ds_isProduction: false,
    docuSignObj: {}
  },
  fingerSignaturePopupState: {
    showPopup: false,
  },
  assignSalesPerson: Map({
    visible: false,
    job: null,
    popupAction: null,
    selectedId: 0
  }), // assign sales person in JobBoard

  // assign fabricator or store to something
  assignEntity: Map({
    visible: false,
    entitiesType: null, // fabricators | stores, what to show in the popup
    entityId: 0, // Id of master entity, userId, employeeId
    entityType: null, // type of master entity, Employee
    allEntities: List(),
    allPossibleEntities: [], // simple array with all values
    selectedEntities: Map(),
    totalPages: 0,
    headerText: '',
    savedSuccessfully: false,
    activeFabricatorIdJob: null // this is specifically for Job Board, active store that is assigned on a job
  }),
  entitiesLoading: false, // shows loader in assign popup

  importFabricators: false,
  exportFabricators: false,

  clonePricingPresetsInto: false,
  showJobPaymentPopup: false,
  showJobEditPopup: false,
  showJobPurchaseOrderPopup: false,
  pricingPopupOpened: false,
  allowPricingPopups: false, // do not allow it to be in the dom until pricing page is opened
  signaturePadPopup: {
    opened: false,
    signatureImage: "",
    onSignCallBack: null,
  },

  // layer 3
  inProgress: {
    show: false,
    title: '',
    message: '',
    useIntl: false
  },

  // layer 4
  errorBox: {
    show: false,
    title: null,
    isLeftButtonVisible: false,
    leftButtonText: null,
    isRightButtonVisible: false,
    rightButtonText: null,
    callback: null
  },

  popupLayer: false,
  popupLayer1: false,
  popupLayer2: false,
  popupLayer3: false,
  popupLayer4: false,

  modal: {
    visible: false,
    message: "",
    buttons: []
  },

  uiPopupState: getDefaultUiPopupState(),
};

function selectSalesPerson(state, id) {
  let sp = state.assignSalesPerson;
  sp = sp.set('selectedId', id);
  return { ...state, assignSalesPerson: sp };
}

export const assignEntity = state => state.assignEntity;
const selectedEntities = state => assignEntity(state).get('selectedEntities');

function showAssignEntity(state, config) {
  let ae = assignEntity(state);
  ae = ae.merge(config);
  ae = ae.set('allEntities', Map());
  ae = ae.set('selectedEntities', Map());
  return { ...state, assignEntity: ae };
}

function assignEntityResetStatus(state) {
  let ae = assignEntity(state);
  ae = ae.set('savedSuccessfully', false);
  return { ...state, assignEntity: ae };
}

function assignEntityResetEntities(state) {
  let ae = assignEntity(state);
  ae = ae.set('allPossibleEntities', []);
  return { ...state, assignEntity: ae };
}

function handleFabricatorsReceived(state, data) {
  let ae = state.assignEntity;
  ae = ae.set('totalPages', data.totalPages);
  const allPossibleEntities = state.assignEntity.get("allPossibleEntities");
  const allEntities = fromJS((data.rows || []).map(entity => {
    return allPossibleEntities.find(en => en.id === entity.id) || entity // here we check if we already downloaded and changed entity
  }))
  ae = ae.set('allEntities', allEntities);
  ae = ae.set('allPossibleEntities', _.uniqBy([...ae.get("allPossibleEntities"), ...data.rows], "id"));
  return { ...state, assignEntity: ae, entitiesLoading: false };
}

function handleAssignEntityCheckName(state, data, propName) {
  let ae = assignEntity(state);
  let list = ae.get('allEntities');
  let selMap = ae.get('selectedEntities');
  const singleSelection = ae.get('singleSelection');
  const { itemId, checked } = data;
  const idx = list.findIndex(e => e.get('id') === itemId);
  const origItem = list.get(idx);
  let selItem = selMap.get(itemId, null);

  if (!selItem) {
    selItem = Map(list[idx]);
    selItem = selItem.setIn(['original'], origItem);
    selMap = selMap.setIn([itemId], selItem);
  }

  if (singleSelection) {
    selMap = new Map();
    for (let i = 0; i < list.size; i++) {
      if (i !== idx) {
        list = list.setIn([i, propName], false);
      }
    }
  }

  const updateCheckProperty = (propName) => {
    return list.setIn([idx, propName], checked);
  }

  ae = ae.set('allEntities', updateCheckProperty(propName));
  ae = ae.set("allPossibleEntities", [...ae.get("allPossibleEntities").map(entity => {
    if (entity.id === itemId) {
      return { ...entity, [propName]: checked }
    }
    return entity
  })]);
  ae = ae.set('selectedEntities', selMap.set(itemId, selItem));
  ae = ae.set('activeFabricatorIdJob', null);
  return {
    ...state,
    assignEntity: ae
  };
}
function handleAssignSeveralEntitiesCheckName(state, actionPayload) {
  let ae = assignEntity(state);
  let allEntities = ae.get('allEntities');
  let selMap = ae.get('selectedEntities');
  let allPossibleEntities = ae.get("allPossibleEntities");

  const {propName, value} = actionPayload;

  allEntities.toJS().map((entity, index) => {
    const {id} = entity;
    let selItem = selMap.get(id, null);
    if (!selItem) {
      selItem = Map(allEntities[index]);
      selItem = selItem.setIn(['original'], entity);
      selMap = selMap.setIn([id], selItem);
    }
    allEntities = allEntities.setIn([index, propName], value);
    allPossibleEntities = allPossibleEntities.map(entity => {
      if (entity.id === id) {
        return { ...entity, [propName]: value }
      }
      return entity
    });
  });

  ae = ae.set('allEntities', allEntities);
  ae = ae.set('selectedEntities', selMap);
  ae = ae.set('allPossibleEntities', allPossibleEntities);
  ae = ae.set('activeFabricatorIdJob', null);
  return {
    ...state,
    assignEntity: ae
  };
}

function handleAssignEntitySaved(state) {
  let ae = assignEntity(state);
  ae = ae.set('visible', false);
  ae = ae.set('savedSuccessfully', true);
  return { ...state, assignEntity: ae };
}

function handleAssignEntitySaving(state) {
  let ae = assignEntity(state);
  ae = ae.set('savedSuccessfully', true);
  return { ...state, assignEntity: ae };
}

export const getChangedEntities = (state) => {
  let se = selectedEntities(state);
  let res = [];
  const ae = state.assignEntity.get("allPossibleEntities");
  se.forEach((value, itemId) => {
    const item = ae.find(item => item.id === itemId);
    if (item.isAssociated !== value.getIn(['original', 'isAssociated']) ||
      item.isLicensedAdmin !== value.getIn(['original', 'isLicensedAdmin'])) {
      res.push(item);
    }
  });

  return res;
}

function setPopupLayerVisibility(state) {

  const allowPopupsConditions = [
    state.jobBoard,
    state.calendar,
    state.filterGroupVisualStyle,
    state.filtersAssignToFeatures,
    state.filtersAssignToStones,
    state.showSwitchUserPopup,
    state.jobBoardExportPopupVisible,
    state.uiPopupState.opened,
  ]

  const allowPopupsConditions1 = [
    state.scheduleEntry,
    state.assignSalesPerson.get('visible'),
    state.assignEntity.get('visible'),
    state.chooseEmailTemplate,
    state.showFeatureGroupImagePopup,
    state.showPaymentGatewayPopup,
    state.showManufacturerFiltersPopup,
    state.showCliqSubMidInfoPopup,
    state.showCreditCardPopup,
    state.permissionsPopupState.showPopup,
    (state.showCategoryImagePopup || state.showCategoryImagePopup === 0),
    state.resetPasswordPopupState.showPopup,
    state.docuSignPopupState.showPopup,
    state.fingerSignaturePopupState.showPopup,
    state.questionPopupState.showPopup,
    state.showAssignQuotePopup,
    state.showJobBoardFiltersPopup,
    state.wizardPopupOpened,
    state.featuresSetupTogglePopupOpened,
    state.featuresSetupDeletePopupOpened,
    state.showShippingSetupPopup,
    state.showMarkUpDownPopup,
    state.showJobPaymentPopup,
    state.showJobEditPopup,
    state.showJobPurchaseOrderPopup,
    state.signaturePadPopup.opened,
  ];

  state.popupLayer = allowPopupsConditions.some(condition => condition);
  state.popupLayer1 = allowPopupsConditions1.some(condition => condition);

  // add here more for layer 1 of popups

  state.popupLayer3 = state.inProgress.show;

  state.popupLayer4 = state.errorBox.show;
}

function saveAssignEntityPopupData(state) {
  let assignEntity = state.assignEntity;

  assignEntity = assignEntity.set('visible', false);

  return { ...state, assignEntity };
}

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.JOB_BOARD_SHOW_LOG_WINDOW:
      state = { ...state, jobBoard: action.payload.show };
      break;
    case actionTypes.CALENDAR_SHOW:
      state = { ...state, calendar: action.payload.show };
      break;
    case actionTypes.CALENDAR_SHOW_SCHEDULE_ENTRY:
    case actionTypes.CALENDAR_SHOW_SCHEDULE_ENTRY_DOCS_DOCUMENTS_ONLY:
      state = { ...state, scheduleEntry: action.payload.show };
      break;
    case actionTypes.CALENDAR_SCHEDULE_ENTRY_SAVED:
      state = { ...state, scheduleEntry: false };
      break;
    case actionTypes.POPUP_ERROR_BOX:
      state = { ...state, errorBox: _.merge(state.errorBox, action.payload) };
      break;
    case actionTypes.POPUP_ERROR_BOX_BUTTON_CLICK:
      if (state.errorBox.callback)
        state.errorBox.callback();
      state = { ...state, errorBox: _.merge(state.errorBox, action.payload) };
      break;
    case actionTypes.POPUP_IN_PROGRESS:
      action.payload.useIntl = action.payload.useIntl || false;
      state = { ...state, inProgress: _.merge(state.inProgress, action.payload) };
      break;
    case actionTypes.POPUP_MESSAGE_BOX_SHOW:
      state = { ...state, messageBox: action.payload };
      break;
    case actionTypes.POPUP_MESSAGE_BOX_COMPONENT_SHOW:
      state = { ...state, messageBoxComponent: action.payload };
      break;
    case actionTypes.POPUP_TOGGLE_MODAL:
      state = { ...state, modal: action.payload };
      break;
    case actionTypes.POPUP_ASSIGN_SALES_PERSON:
      const p = action.payload;
      let m = Map({ ...p });
      m = m.set('selectedId', +p.data);
      state = { ...state, assignSalesPerson: m };
      break;
    case actionTypes.SALES_PEOPLE_SUCCESS:
      const o = _.find(action.payload.rows, { isAssigned: true });
      if (o) {
        let m = state.assignSalesPerson;
        m = m.set('selectedId', o.userId);
        return { ...state, assignSalesPerson: m };
      }
      return state;
    case actionTypes.POPUP_IMPORT_FABRICATOR:
      state.importFabricators = action.payload.visible;
      return state;
    case actionTypes.POPUP_SHOW_FABRICATORS_EXPORT_POPUP:
      state.exportFabricators = action.payload.visible;
      return state;
    case actionTypes.POPUP_SHOW_CLONE_PRICING_PRESETS_INTO_POPUP:
      state.clonePricingPresetsInto = action.payload.visible;
      return state;
    case actionTypes.SALES_PERSON_SELECT:
      return selectSalesPerson(state, action.payload);
    case actionTypes.POPUP_NEW_ENTITY_SET_MASTER_PROFILE: {
      let m = state.assignSalesPerson;
      m = m.set('visible', false);
      state = { ...state, assignSalesPerson: m };
    }
      break;
    case actionTypes.POPUP_ASSIGN_ENTITY:
      state = showAssignEntity(state, action.payload);
      break;
    case actionTypes.ENTITIES_ASSIGN_REMOVE:
      state = assignEntityResetEntities(state);
      break;
    case actionTypes.POPUP_ASSIGN_ENTITY_RESET_STATUS:
      state = assignEntityResetStatus(state);
      break;
    case actionTypes.FABRICATORS_ALL_REQUEST:
      state = {...state, entitiesLoading: true };
      break;
    case actionTypes.FABRICATORS_ALL_SUCCESS:
      state = handleFabricatorsReceived(state, action.payload);
      break;
    case actionTypes.POPUP_ASSIGN_ENTITY_CHECK_NAME:
      state = handleAssignEntityCheckName(state, action.payload, 'isAssociated');
      break;
    case actionTypes.POPUP_ASSIGN_ENTITY_CHECK_LICENSED_ADMIN:
      state = handleAssignEntityCheckName(state, action.payload, 'isLicensedAdmin');
      break;
    case actionTypes.POPUP_ASSIGN_MULTIPLE_ENTITIES_CHECK:
      state = handleAssignSeveralEntitiesCheckName(state, action.payload);
      break;
    case actionTypes.POPUP_ASSIGN_ENTITY_SAVING:
      state = handleAssignEntitySaving(state);
      break;
    case actionTypes.POPUP_ASSIGN_ENTITY_SAVED:
      state = handleAssignEntitySaved(state);
      break;
    case actionTypes.POPUP_CHOOSE_EMAIL_TEMPLATES_BOX_SHOW:
      state = { ...state, chooseEmailTemplate: action.payload.visible };
      break;
    case actionTypes.POPUP_CHOOSE_EMAIL_TEMPLATE:
      state = { ...state, chosenEmailTemplate: action.payload.template };
      break;
    case actionTypes.POPUP_FILTER_GROUP_VISUAL_STYLE:
      state = { ...state, filterGroupVisualStyle: action.payload.show };
      break;
    case actionTypes.POPUP_FILTER_GROUP_VISUAL_STYLE_SELECTED:
      state = { ...state, filterGroupVisualStyle: false };
      break;
    case actionTypes.POPUP_FILTER_ASSIGN_TO_STONE:
      state = { ...state, filtersAssignToStones: action.payload.show };
      break;
    case actionTypes.POPUP_FILTER_ASSIGN_TO_FEATURES:
      state = { ...state, filtersAssignToFeatures: action.payload.show };
      break;
    case actionTypes.POPUP_JOB_BOARD_EXPORT_SHOW:
      state = { ...state, jobBoardExportPopupVisible: action.payload.show };
      break;
    case actionTypes.SHOW_SWITCH_USER_WINDOW:
      state = { ...state, showSwitchUserPopup: action.payload.show };
      break;
    case actionTypes.NEW_SCOPE_TOGGLE_CATEGORY_IMAGE_POPUP:
      state = { ...state, showCategoryImagePopup: action.payload.qtCategoryImageEditIndex };
      break;
    case actionTypes.NEW_SCOPE_TOGGLE_FEATURE_GROUP_IMAGE_POPUP:
      state = { ...state, showFeatureGroupImagePopup: !!action.payload.activeImageEditFeatureGroup };
      break;
    case actionTypes.POPUP_SHOW_PAYMENT_GATEWAY_POPUP:
      state = { ...state, showPaymentGatewayPopup: action.payload.showPaymentGatewayPopup };
      break;
    case actionTypes.POPUP_SHOW_MANUFACTURER_FILTERS_POPUP:
      state = { ...state, showManufacturerFiltersPopup: action.payload.showManufacturerFiltersPopup };
      break;
    case actionTypes.POPUP_SHOW_CLIQ_SUBMID_INFO_POPUP:
      state = { ...state, showCliqSubMidInfoPopup: action.payload.showCliqSubMidInfoPopup };
      break;
    case actionTypes.POPUP_SHOW_CREDIT_CARD_POPUP:
      state = { ...state, showCreditCardPopup: action.payload.showCreditCardPopup };
      break;
    case actionTypes.POPUP_SHOW_PERMISSIONS_POPUP:
      state = { ...state, permissionsPopupState: Object.assign({}, state.permissionsPopupState, action.payload.permissionsPopupState) };
      break;
    case actionTypes.POPUP_SET_RESET_PASSWORD_POPUP_STATE:
      state = { ...state, resetPasswordPopupState: Object.assign({}, state.resetPasswordPopupState, action.payload.resetPasswordPopupState) };
      break;
    case actionTypes.POPUP_SET_DOCUSIGN_POPUP_STATE:
      state = { ...state, docuSignPopupState: Object.assign({}, state.docuSignPopupState, action.payload.docuSignPopupState) };
      break;
    case actionTypes.POPUP_SET_FINGER_SIGNATURE_POPUP_STATE:
      state = { ...state, fingerSignaturePopupState: Object.assign({}, state.fingerSignaturePopupState, action.payload.fingerSignaturePopupState) };
      break;
    case actionTypes.POPUP_SET_QUESTION_POPUP_STATE:
      state = { ...state, questionPopupState: Object.assign({}, state.questionPopupState, action.payload.questionPopupState) };
      break;
    case actionTypes.POPUP_ASSIGN_ENTITY_SAVE_TO_STORE:
      state = saveAssignEntityPopupData(state, action);
      break;
    case actionTypes.TOGGLE_SHOW_ASSIGN_QUOTE_POPUP:
      state = { ...state, showAssignQuotePopup: action.payload.showAssignQuotePopup };
      break;
    case actionTypes.JOB_BOARD_SHOW_FILTERS_POPUP:
      state = { ...state, showJobBoardFiltersPopup: action.payload.showJobBoardFiltersPopup };
      break;
    case actionTypes.SET_WIZARD_POPUP_OPENED:
      state = { ...state, wizardPopupOpened: action.payload.wizardPopupOpened };
      break;
    case actionTypes.FEATURES_SETUP_TOGGLE_POPUP_OPENED:
      state = { ...state, featuresSetupTogglePopupOpened: action.payload.featuresSetupTogglePopupOpened };
      break;
    case actionTypes.FEATURES_SETUP_DELETE_POPUP_OPENED:
      state = { ...state, featuresSetupDeletePopupOpened: action.payload.featuresSetupDeletePopupOpened };
      break;
    case actionTypes.FEATURES_SETUP_SHOW_SHIPPING_SETUP_POPUP:
      state = { ...state, showShippingSetupPopup: action.payload.showShippingSetupPopup };
      break;
    case actionTypes.FEATURES_SETUP_SHOW_MARK_UP_DOWN_POPUP:
      state = { ...state, showMarkUpDownPopup: action.payload.showMarkUpDownPopup };
      break;
    case actionTypes.JOB_BOARD_SHOW_PAYMENT_POPUP:
      state = { ...state, showJobPaymentPopup: action.payload.showJobPaymentPopup };
      break;
    case actionTypes.JOB_BOARD_SHOW_EDIT_POPUP:
      state = { ...state, showJobEditPopup: action.payload.showJobEditPopup };
      break;
    case actionTypes.JOB_BOARD_SHOW_PURCHASE_ORDER_POPUP:
      state = { ...state, showJobPurchaseOrderPopup: action.payload.showJobPurchaseOrderPopup };
      break;
    case actionTypes.PRICING_SHOW_PRICING_POPUP:
      state = { ...state, pricingPopupOpened: action.payload.pricingPopupOpened };
      break;
    case actionTypes.POPUP_SET_SIGNATURE_POPUP_STATE:
      state = { ...state, signaturePadPopup: {...state.signaturePadPopup, ...action.payload} };
      break;
    case actionTypes.PRICING_POPUP_ALLOW:
      state = { ...state, ...action.payload};
      break;
    case actionTypes.SET_UI_POPUP_STATE:
      state = action.payload.uiPopupState.opened
        ? { ...state, ...action.payload}
        : {...state, uiPopupState: getDefaultUiPopupState()};
      break;
  }

  setPopupLayerVisibility(state);
  return state;
}

